import { ROLES } from "../constants/roles";

const ROLE_BADGE: Record<string, string> = {
  [ROLES.SUPER_ADMIN]: "bg-purple-100 text-purple-700",
  [ROLES.ADMIN]: "bg-blue-100 text-blue-700",
  [ROLES.ANALYST]: "bg-green-100 text-green-700",
  [ROLES.VIEWER]: "bg-gray-100 text-gray-600",
};

/** Tailwind classes for a role pill. Falls back to neutral for unknown roles. */
export function roleBadgeClass(role?: string | null): string {
  return ROLE_BADGE[role ?? ""] ?? "bg-gray-100 text-gray-600";
}

const STATUS_BADGE: Record<string, string> = {
  active: "bg-green-100 text-green-700",
  paused: "bg-gray-100 text-gray-500",
  failed: "bg-red-100 text-red-600",
};

export function statusBadgeClass(status?: string | null): string {
  return STATUS_BADGE[status ?? ""] ?? "bg-gray-100 text-gray-600";
}
